export const PETS_OFFERS_FILTER_EVENTS = {
  PETS_OFFERS_FILTER_BY_COMPANY: 'pets-offers-filter-by-company',
};